// extracted by mini-css-extract-plugin
module.exports = {"upload":"Upload_upload__3UIjP","upload--empty":"Upload_upload--empty__2x4hP"};